import fetch from 'isomorphic-fetch';
// import router from '@/router';
import Message from '@/components/CloudIView/components/message';
import store from '@/store/index';
import { paramsStringify } from './util';

const isBlob = data => Object.prototype.toString.call(data) === '[object Blob]';
const REQUEST_TIMEOUT = 120; // 请求超时时间：秒
let statusCode;

// 向服务器发送请求返回的状态
function checkStatus(response) {
  if ((response.status >= 200 && response.status < 300) || response.status === 1000) {
    statusCode = response.status;
    return response;
  }
  if (response.status === 401 || response.status === 403) {
    // 验证不通过，重新登录
    store.dispatch('user/logout');
    statusCode = response.status;
    return false;
  }
  // 请求错误
  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}

// 对返回的数据装换为json格式
function parseJSON(response) {
  const contentType = response.headers.get('Content-Type');
  return contentType === 'application/pdf' ||
    contentType === 'application/vnd.ms-excel;charset=utf-8'
    ? response.blob()
    : response.json();
}

// 对response 数据进行处理
function httpResponse(res, msgType) {
  if (isBlob(res)) return res;
  if (res) {
    switch (window.parseInt(res.status)) {
      // 请求成功
      case 200:
        return res;
      case 201:
        return res;
      case 1000:
        return res;
      default: {
        // 是否是长消息
        const isLongMsg = res.message[store.state.lang].length > 30;
        // 根据msgType决定使用哪种提示类型，当前只支持传入warning和error
        if (msgType === 'warning') {
          if (isLongMsg) {
            Message.warning({
              duration: 60,
              closable: true,
              content: res.message[store.state.lang],
            });
          } else {
            Message.warning({
              content: res.message[store.state.lang],
              duration: 5,
            });
          }
        } else {
          if (isLongMsg) {
            Message.error({
              duration: 60,
              closable: true,
              content: res.message[store.state.lang],
            });
          } else {
            Message.error({
              content: res.message[store.state.lang],
              duration: 5,
            });
          }
        }
        return false;
      }
    }
  } else {
    Message.error('网络错误，请刷新重试！');
    return false;
  }
}

// 是否正在发布
function updateFlag() {
  Promise.race([fetch('/api-luttica/job/job/updateFlag')])
    .then(parseJSON)
    .then(response => {
      if (response && response.status === 200) {
        return response.data.update_flag;
      }
    })
    .catch(error => {
      console.log('---updataFlag---');
      return false;
    });
}
/**
 * Requests a URL, return a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
export default function request(url, options = {}) {
  // const updata = updateFlag();
  // if (updata) {
  //   window.location.href = window.location.origin + '/updating';
  // }
  const { method = 'get', headers = {}, params = {}, body = {} } = options;
  const requestUrl = Object.keys(params).length
    ? `${process.env.VUE_APP_REQUEST_BASE_URL}${url}?${paramsStringify(params)}`
    : `${process.env.VUE_APP_REQUEST_BASE_URL}${url}`;
  let requestOptions = {};
  const contentType = 'application/json';
  const authorization = store.state.user.access_token
    ? {
        Authorization: `Bearer ${store.state.user.access_token}`,
      }
    : {};
  if (method.toUpperCase() === 'GET') {
    requestOptions = {
      method,
      headers: new Headers({
        tenant_id: encodeURIComponent(store.state.user.tenantId),
        lang_id: store.state.lang === 'cn' ? 1 : 2,
        menu_id: 0,
        ...authorization,
        ...headers,
      }),
    };
  } else {
    let requestBody = {};
    // 判断传入的参数是否是formData
    if (Object.prototype.toString.call(body) === '[object FormData]') {
      requestBody = body;
      requestOptions = {
        method,
        headers: new Headers({
          tenant_id: encodeURIComponent(store.state.user.tenantId),
          lang_id: store.state.lang === 'cn' ? 1 : 2,
          menu_id: 0,
          ...authorization,
          ...headers,
        }),
        body: requestBody,
      };
    } else {
      requestBody = JSON.stringify(body);
      requestOptions = {
        method,
        headers: new Headers({
          tenant_id: encodeURIComponent(store.state.user.tenantId),
          lang_id: store.state.lang === 'cn' ? 1 : 2,
          menu_id: 0,
          'content-type': contentType,
          ...authorization,
          ...headers,
        }),
        body: requestBody,
      };
    }
  }
  return Promise.race([
    fetch(requestUrl, { ...requestOptions, credentials: 'include' }),
    new Promise((resolve, reject) => {
      setTimeout(
        () =>
          reject(
            new Error(
              'System back-end service is abnormal, please contact the system administrator!'
            )
          ),
        REQUEST_TIMEOUT * 1000
      );
    }),
  ])
    .then(checkStatus)
    .then(parseJSON)
    .then(response => httpResponse(response, options.errorType || 'error'))
    .catch(error => {
      console.error(error.response);
      if (statusCode === 401 || statusCode === 403) {
        return false;
      }
      Message.error({
        content:
          store.state.lang === 'cn'
            ? '网络错误，请刷新重试！'
            : 'Network error, please refresh and retry!',
        duration: 5,
      });
      return false;
    });
}
